const adminOptions = {
  showDeletedTitle: 'Recursos de Admin',
  showDeleted: 'Mostrar apenas Equipamentos Deletados',
  showDeletedChipLabel: 'Equipamentos Deletados',
};

export default adminOptions;